import { useEffect } from "react";
import { clearAuthState } from "../utils/authUtils";

// If a Cognito hosted-UI / AWS page is ever loaded, bounce back to our /login.
const AuthGuard = ({ children }) => {
  useEffect(() => {
    const isOnAWSPage =
      window.location.href.includes("signin.aws.amazon.com") ||
      window.location.href.includes("cognito") ||
      window.location.href.includes("amazonaws.com");

    if (isOnAWSPage) {
      clearAuthState();
      window.location.replace("/login");
    }
  }, []);

  return children;
};

export default AuthGuard;
